import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    root: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
        paddingInline: theme.spacing(2),
        transition: "background-color 0.3s ease",
        "&:hover": {
            backgroundColor: theme.palette.background.main,
        },
        "&:has(> button:focus-visible)": {
            outline: `2px solid ${theme.palette.secondary.main}!important`,
            outlineOffset: "2px",
            borderRadius: theme.shape.borderRadius,
        },
    },
    titleButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        padding: theme.spacing(2, 0),
        border: "none",
        background: "transparent",
        cursor: "pointer",
        textAlign: "left",
        "&:focus-visible": {
            outline: "none",
        },
    },
    titleText: {
        color: theme.palette.secondary.main,
        flex: 1,
        paddingRight: theme.spacing(2),
    },
    arrowIconBase: {
        color: theme.palette.secondary.main,
        flexShrink: 0,
        height: 12,
        width: 12,
        transition: "transform 0.3s ease",
        "& path": {
            fill: theme.palette.primary.main,
        },
    },
    arrowIcon: {
        transform: "rotate(0deg)",
    },
    arrowIconExpanded: {
        transform: "rotate(180deg)",
    },
    content: {
        paddingBottom: theme.spacing(2),
        color: theme.palette.text.primary,
        "& a": {
            color: theme.palette.primary.main,
            textDecoration: "underline",
        },
    },
}));
